module.exports = "<footer>\n  <p class=\"version\">Version: {{ version }}</p>\n</footer>"